<template>
  <el-dialog
    title="租房预定"
    :visible.sync="dialogVisible"
    width="700px"
    :close-on-click-modal="false"
    @close="handleClose"
    class="reserve-dialog"
    top="10vh"
  >
    <div class="dialog-content-wrapper">
      <el-form
        ref="formRef"
        :model="formData"
        :rules="formRules"
        label-width="120px"
        size="small"
        class="reserve-form"
      >
        <!-- ====== 第一行：房屋地址 ====== -->
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="房屋地址" prop="房屋地址">
              <el-input v-model="formData.房屋地址" disabled />
            </el-form-item>
          </el-col>
        </el-row>

        <!-- ====== 第二行：租客姓名 + 联系电话 ====== -->
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="租客姓名" prop="租客姓名" required>
              <el-input v-model="formData.租客姓名" placeholder="请输入租客姓名" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话" prop="联系电话" required>
              <el-input
                v-model="formData.联系电话"
                placeholder="请输入联系电话"
                style="width:100%"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <!-- ====== 第三行：定金金额 + 预定时间 ====== -->
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="定金金额" prop="定金金额" required>
              <el-input-number
                v-model="formData.定金金额"
                :min="0"
                :precision="2"
                :step="100"
                controls-position="right"
                placeholder="请输入定金金额"
                style="width:100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="预定时间" prop="预定时间" required>
              <el-date-picker
                v-model="formData.预定时间"
                type="date"
                placeholder="请选择预定时间"
                value-format="timestamp"
                style="width:100%"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <!-- ====== 附件上传区域 ====== -->
        <div class="form-section">
          <div class="section-title">出租预定凭证</div>

          <div class="file-group">
            <div class="file-group-header">
              <span class="file-group-title">预定凭证</span>
              <el-button type="primary" size="small" icon="el-icon-upload2" @click="openUploadDialog('出租预定凭证')">
                添加凭证
              </el-button>
            </div>
            <el-table :data="fileList" border stripe size="small">
              <el-table-column type="index" label="序号" width="60" align="center" />
              <el-table-column prop="show_name" label="文件名称" min-width="200" show-overflow-tooltip />
              <el-table-column label="预览" width="150" align="center">
                <template slot-scope="{ row }">
                  <div v-if="isImage(row.suffix) && row.preview_url" class="preview-thumbnail">
                    <el-image
                      :src="row.preview_url"
                      fit="cover"
                      style="width: 80px; height: 60px; border-radius: 4px; cursor: pointer;"
                      :preview-src-list="[row.preview_url]"
                    />
                  </div>
                  <span v-else class="preview-placeholder">仅支持图片预览</span>
                </template>
              </el-table-column>
              <el-table-column prop="upload_time" label="上传时间" width="170" align="center" />
              <el-table-column label="操作" width="160" align="center">
                <template slot-scope="{ row }">
                  <!-- <el-button type="text" size="mini" @click="handlePreviewFile(row)">查看</el-button> -->
                  <el-button type="text" size="mini" style="color: #f56c6c;" @click="handleRemoveFile(row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div v-if="fileList.length === 0" class="empty-tip">
              暂无凭证文件
            </div>
          </div>
        </div>
      </el-form>
    </div>

    <!-- 底部按钮 -->
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">确认预定</el-button>
    </span>

    <!-- ====== 上传文件弹窗 ====== -->
    <el-dialog
      :title="uploadDialog.title"
      :visible.sync="uploadDialog.visible"
      width="520px"
      :append-to-body="true"
      :close-on-click-modal="false"
      @close="resetUploadForm"
    >
      <el-form :model="uploadForm" label-width="100px" size="small">
        <el-form-item label="选择文件" required>
          <el-upload
            ref="uploadRef"
            :auto-upload="false"
            :limit="1"
            :on-change="handleFileChange"
            :on-remove="handleFileRemove"
            action="#"
            accept=".jpg,.jpeg,.png,.pdf,.doc,.docx"
          >
            <el-button size="small" type="primary">点击选择文件</el-button>
            <span slot="tip" class="el-upload__tip">支持 jpg、jpeg、png、pdf、doc、docx</span>
          </el-upload>
          <div v-if="uploadForm.fileName" style="margin-top: 8px; font-size: 13px; color: #409EFF;">
            已选择：{{ uploadForm.fileName }}
          </div>
        </el-form-item>

        <!-- 图片预览 -->
        <el-form-item label="文件预览" v-if="uploadForm.localPreviewUrl">
          <el-image
            :src="uploadForm.localPreviewUrl"
            fit="cover"
            style="width: 100%; max-height: 200px; border-radius: 4px;"
          />
        </el-form-item>
        <el-form-item label="文件预览" v-else-if="uploadForm.fileName && !uploadForm.localPreviewUrl">
          <span style="color: #909399;">非图片文件，上传后可查看</span>
        </el-form-item>

        <el-form-item label="备注">
          <el-input v-model="uploadForm.bz" placeholder="请输入备注（可选）" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="uploadDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="handleUploadSubmit" :loading="uploading">确认</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { sqlBaseApi } from '@/api/通用/sqlBaseApi'
import { fileMethod } from '@/api/files/fileMethod'

export default {
  name: 'ReserveDialog',

  props: {
    visible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      dialogVisible: this.visible,
      submitting: false,
      uploading: false,

      // 表单数据
      formData: {
        房屋地址: '',
        租客姓名: '',
        联系电话: '',
        定金金额: null,
        预定时间: null,
        房源ID: '',
        业务状态: '已预订'
      },

      formRules: {
        租客姓名: [
          { required: true, message: '请输入租客姓名', trigger: 'blur' }
        ],
        联系电话: [
          { required: true, message: '请输入联系电话', trigger: 'blur' }
        ],
        定金金额: [
          { required: true, message: '请输入定金金额', trigger: 'blur' }
        ],
        预定时间: [
          { required: true, message: '请选择预定时间', trigger: 'change' }
        ]
      },

      // ====== 附件列表（仅存储文件信息，数据库记录在 submitForm 时插入） ======
      fileList: [],

      // 上传弹窗
      uploadDialog: {
        visible: false,
        title: '添加凭证'
      },
      uploadForm: {
        file: null,
        fileName: '',
        type_1: '出租预定凭证',
        bz: '',
        localPreviewUrl: ''
      }
    }
  },

  watch: {
    visible(val) {
      this.dialogVisible = val
      if (val && this.rowData) {
        this.initData()
      }
    },
    dialogVisible(val) {
      this.$emit('update:visible', val)
      if (!val) {
        this.resetForm()
      }
    }
  },

  methods: {
    // ====== 初始化数据 ======
    initData() {
      if (!this.rowData) return

      const data = this.rowData

      this.formData = {
        房屋地址: data.房屋地址 || '',
        租客姓名: '',
        联系电话: '',
        定金金额: null,
        预定时间: null,
        房源ID: String(data.id),
        业务状态: '已预订'
      }

      this.fileList = []

      this.$nextTick(() => {
        if (this.$refs.uploadRef) {
          this.$refs.uploadRef.clearFiles()
        }
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate()
        }
      })
    },

    // ====== 重置表单 ======
    resetForm() {
      this.formData = {
        房屋地址: '',
        租客姓名: '',
        联系电话: '',
        定金金额: null,
        预定时间: null,
        房源ID: '',
        业务状态: '已预订'
      }
      this.fileList = []
      this.submitting = false
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate()
        }
        if (this.$refs.uploadRef) {
          this.$refs.uploadRef.clearFiles()
        }
      })
    },

    // ====== 取消 ======
    handleCancel() {
      const hasData = Object.values(this.formData).some(val => {
        if (val === null || val === '' || val === undefined) return false
        if (Array.isArray(val) && val.length === 0) return false
        return true
      })

      if (hasData || this.fileList.length > 0) {
        this.$confirm('确定要取消吗？已填写的数据将丢失。', '提示', {
          type: 'warning'
        }).then(() => {
          this.dialogVisible = false
        }).catch(() => {})
      } else {
        this.dialogVisible = false
      }
    },

    // ====== 关闭弹窗 ======
    handleClose() {
      this.dialogVisible = false
    },

    // ====== 判断是否为图片 ======
    isImage(suffix) {
      if (!suffix) return false
      const imageTypes = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp']
      return imageTypes.includes(suffix.toLowerCase())
    },

    // ====== 获取文件后缀 ======
    getFileSuffix(fileName) {
      const parts = fileName.split('.')
      return parts.length > 1 ? parts[parts.length - 1] : ''
    },

    // ====== 打开上传弹窗 ======
    openUploadDialog() {
      this.uploadDialog.title = '添加凭证'
      this.uploadDialog.visible = true

      this.uploadForm.file = null
      this.uploadForm.fileName = ''
      this.uploadForm.type_1 = '出租预定凭证'
      this.uploadForm.bz = ''
      this.uploadForm.localPreviewUrl = ''

      this.$nextTick(() => {
        if (this.$refs.uploadRef) {
          this.$refs.uploadRef.clearFiles()
        }
      })
    },

    // ====== 文件选择变化 ======
    handleFileChange(file) {
      this.uploadForm.file = file.raw
      this.uploadForm.fileName = file.name
      this.uploadForm.localPreviewUrl = ''

      if (this.isImage(this.getFileSuffix(file.name))) {
        const reader = new FileReader()
        reader.onload = (e) => {
          this.uploadForm.localPreviewUrl = e.target.result
        }
        reader.readAsDataURL(file.raw)
      }
    },

    // ====== 文件移除 ======
    handleFileRemove() {
      this.uploadForm.file = null
      this.uploadForm.fileName = ''
      this.uploadForm.localPreviewUrl = ''
    },

    // ====== 重置上传表单 ======
    resetUploadForm() {
      this.uploadForm.file = null
      this.uploadForm.fileName = ''
      this.uploadForm.bz = ''
      this.uploadForm.localPreviewUrl = ''
      this.uploading = false
      if (this.$refs.uploadRef) {
        this.$refs.uploadRef.clearFiles()
      }
    },

    // ====== 上传附件（仅上传到服务器，不插入数据库） ======
    async handleUploadSubmit() {
      if (!this.uploadForm.file) {
        this.$message.warning('请选择文件')
        return
      }

      this.uploading = true

      try {
        // 使用 uploadOnly 仅上传文件到服务器，不插入数据库
        const res = await fileMethod.uploadOnly(this.uploadForm.file)
        console.log('上传返回:', res)

        if (res.code === 200) {
          const data = res.data
          const fileInfo = {
            save_name: data.saveName || '',
            save_path: data.savePath || '',
            show_name: data.showName || this.uploadForm.file.name,
            show_path: data.showPath || '',
            suffix: data.suffix || this.getFileSuffix(this.uploadForm.file.name),
            type_1: this.uploadForm.type_1,
            bz: this.uploadForm.bz || '',
            upload_time: new Date().toLocaleString(),
            preview_url: (window.applicationConfig?.fileBaseUrl || '') + (data.showPath || '').replace(/^\//, '')
          }

          this.fileList.push(fileInfo)
          this.$message.success('上传成功')
          this.uploadDialog.visible = false
        } else {
          this.$message.error(res.message || '上传失败')
        }
      } catch (error) {
        console.error('上传失败:', error)
        this.$message.error(error.message || '上传失败，请稍后重试')
      } finally {
        this.uploading = false
      }
    },

    // ====== 预览文件 ======
    handlePreviewFile(row) {
      if (row.preview_url) {
        window.open(row.preview_url, '_blank')
      } else {
        this.$message.warning('文件路径不存在')
      }
    },

    // ====== 删除文件（仅从列表中移除） ======
    handleRemoveFile(row) {
      this.$confirm(
        `确认移除文件 "${row.show_name}" 吗？`,
        '提示',
        {
          type: 'warning',
          confirmButtonText: '确认移除',
          cancelButtonText: '取消'
        }
      ).then(() => {
        const index = this.fileList.findIndex(item => item.save_name === row.save_name)
        if (index !== -1) {
          this.fileList.splice(index, 1)
        }
        this.$message.success('已移除')
      }).catch(() => {})
    },

    // ====== 获取所有附件 ======
    getAllFiles() {
      return this.fileList
    },

    // ====== 提交 ======
    async handleSubmit() {
      try {
        await this.$refs.formRef.validate()
      } catch (error) {
        this.$message.warning('请完善表单信息')
        return
      }

      try {
        await this.$confirm('确认预定该房源吗？', '提示', {
          type: 'warning',
          confirmButtonText: '确认预定',
          cancelButtonText: '取消'
        })
      } catch {
        return
      }

      this.submitting = true

      try {
        // 组装 fileList - 使用 uploadOnly 返回的文件信息
        const fileList = this.getAllFiles().map(item => ({
          save_name: item.save_name,
          save_path: item.save_path,
          show_name: item.show_name,
          show_path: item.show_path,
          suffix: item.suffix,
          type_1: item.type_1,
          type_2: '',
          bz: item.bz || ''
        }))

        const submitParams = {
          tableName: '出房管理',
          formData: {
            房屋地址: this.formData.房屋地址,
            房源ID: this.formData.房源ID,
            租客姓名: this.formData.租客姓名,
            联系电话: this.formData.联系电话,
            定金金额: this.formData.定金金额,
            预定时间: this.formData.预定时间 ? Math.floor(this.formData.预定时间 / 1000) : null,
            业务状态: '已预订'
          },
          fileList: fileList
        }

        console.log('预定 submitForm 参数===', submitParams)

        const submitRes = await sqlBaseApi.submitForm(submitParams)
        console.log('预定 submitForm 返回===', submitRes)

        if (submitRes.code !== 200) {
          this.$message.error(submitRes.message || '预定失败')
          this.submitting = false
          return
        }

        // 更新房源状态为"已出租"
        const updateParams = {
          tableName: '房源',
          data: {
            业务状态: '已出租'
          },
          where: {
            id: this.formData.房源ID
          }
        }

        console.log('更新房源状态参数===', updateParams)

        const updateRes = await sqlBaseApi.update(updateParams)
        console.log('更新房源状态返回===', updateRes)

        if (updateRes.code !== 200) {
          this.$message.warning('预定记录已创建，但状态更新失败，请手动刷新')
        } else {
          this.$message.success('预定成功！')
        }

        this.dialogVisible = false
        this.$emit('refresh')

      } catch (error) {
        console.error('预定失败:', error)
        this.$message.error(error.message || '预定失败，请稍后重试')
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style scoped>
.reserve-dialog /deep/ .el-dialog {
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.reserve-dialog /deep/ .el-dialog__body {
  flex: 1;
  overflow: hidden;
  padding: 20px 20px 10px 20px;
}

.reserve-dialog /deep/ .el-dialog__footer {
  border-top: 1px solid #ebeef5;
  padding: 12px 20px;
}

.dialog-content-wrapper {
  max-height: 65vh;
  overflow-y: auto;
  padding-right: 8px;
}

.dialog-content-wrapper::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.dialog-content-wrapper::-webkit-scrollbar-track {
  background: #f0f2f5;
  border-radius: 3px;
}

.dialog-content-wrapper::-webkit-scrollbar-thumb {
  background: #c1c7cd;
  border-radius: 3px;
}

.dialog-content-wrapper::-webkit-scrollbar-thumb:hover {
  background: #a8b0b8;
}

.dialog-content-wrapper {
  scrollbar-width: thin;
  scrollbar-color: #c1c7cd #f0f2f5;
}

.reserve-form /deep/ .el-form-item {
  margin-bottom: 18px;
}

.reserve-form /deep/ .el-form-item__label {
  font-weight: 500;
  color: #606266;
  padding-right: 12px;
}

.reserve-form /deep/ .el-input-number {
  width: 100%;
}

.reserve-form /deep/ .el-input-number .el-input__inner {
  text-align: left;
}

.reserve-form /deep/ .el-select {
  width: 100%;
}

.reserve-form /deep/ .el-date-editor {
  width: 100%;
}

/* ====== 附件分组 ====== */
.file-group {
  margin-bottom: 24px;
}

.file-group:last-child {
  margin-bottom: 0;
}

.file-group-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0 10px 0;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 10px;
}

.file-group-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}

.preview-thumbnail {
  display: flex;
  justify-content: center;
  align-items: center;
}

.preview-placeholder {
  font-size: 12px;
  color: #909399;
}

.empty-tip {
  text-align: center;
  padding: 12px 0;
  color: #909399;
  font-size: 13px;
  background: #f5f7fa;
  border-radius: 4px;
  margin-top: 4px;
}

.form-section {
  margin-top: 10px;
}

.section-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  padding: 8px 0;
  margin-bottom: 12px;
  border-bottom: 2px solid #409EFF;
}

@media (max-width: 768px) {
  .reserve-dialog /deep/ .el-dialog {
    width: 95% !important;
  }
}
</style>